import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { errorMsg } from '../../../../../Apis/functions';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../../Routes/routes';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { TABLES } from '../../../../../Apis/Tables';
import { MODELS } from '../../../../../Apis/Models';

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const EquipmentAndMaterialApp = () => {
    const { t } = useTranslation();
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [selectForDelete, setSelectForDelete] = useState([]);
    // Owned here so the delete modal can clear the select all checkbox of the table and the cards
    const [isAllChecked, setIsAllChecked] = useState(false);
    const navigate = useNavigate();
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const [search, setSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState({});
    const [modified, setModified] = useState(false);
    const option = `${TABLES.EQUIPMENT_MATERIAL}`;
    const moduleId = `${MODELS.EQUIPMENT_MATERIAL}`;
    const [criteria, setCriteria] = useState();
    const dispatch = useDispatch();
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));

    //Navigates to the create screen
    const handleCreate = () => {
        navigate(routes.equipmentAndMaterial.create);
    };
    // Opens confirmation modal to delete selected items
    const handleDeleteSelected = () => {
        const body = selectForDelete;
        dispatch(DeleteItemsApi({ tableName: option, body })).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success) {
                    setDeleteModalShow(false);
                    setSelectForDelete([]);
                    setIsAllChecked(false);
                    setModified(true);
                } else errorMsg(code);
            },
        );
    };

    //Opens the delete modal only when there are selected items, but closes it in any case
    const toggleModal = () => {
        if (deleteModalShow) setDeleteModalShow(false);
        else if (selectForDelete.length > 0) setDeleteModalShow(true);
    };

    return {
        t,
        handleCreate,
        deleteModalShow,
        handleDeleteSelected,
        toggleModal,
        selectForDelete,
        setSelectForDelete,
        isAllChecked,
        setIsAllChecked,
        moduleId,
        criteria,
        search,
        bodyForExport,
        setBodyForExport,
        option,
        view,
        setView,
        setSearch,
        setDeleteModalShow,
        modified,
        setModified,
        contractorId,
        supplierId,
    };
};

export default EquipmentAndMaterialApp;
